'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaMedium = function FaMedium(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm13.3 9.4v26.2q0 0.5-0.3 0.9t-0.8 0.4q-0.3 0-0.7-0.2l-10.4-5.2q-0.5-0.2-0.8-0.7t-0.3-1v-25.5q0-0.4 0.2-0.8t0.7-0.3q0.3 0 1 0.4l11.4 5.7q0 0.1 0 0.1z m1.5 2.3l11.9 19.3-11.9-6v-13.3z m25.2 0.4v23.5q0 0.5-0.3 0.9t-0.9 0.3-1-0.3l-9.9-4.9z m-0.1-2.7q0 0-5.7 9.3t-6.7 10.9l-8.7-14.1 7.2-11.8q0.4-0.6 1.2-0.6 0.3 0 0.6 0.1l12 6q0.1 0.1 0.1 0.2z' })
        )
    );
};

exports.default = FaMedium;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/medium.js
// module id = 898
// module chunks = 168707334958949